import "./_Bootstrap/Bootstrap";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { LayerProvider } from "@onshopfront/components";
import { store } from "./_Bootstrap/RoutingAndStore";
import Developer from "./Developer";
import { DeveloperUIContainer } from "./DeveloperUIContainer";

// Render our application
createRoot(document.getElementById("root") as Element).render(
    <Provider store={store}>
        <BrowserRouter>
            <DeveloperUIContainer>
                <LayerProvider zIndex={22}>
                    <Developer />
                </LayerProvider>
            </DeveloperUIContainer>
        </BrowserRouter>
    </Provider>
);
